// src/lib/api/learningApi.ts — the aggregated candidate learning hub (#74).
// One call returns everything the "Moduler" page renders, replacing the former
// onboarding + program + module + progress + training-record fan-out.
import { getApiClient } from './client';
import type { MyLearningResponse } from '@/lib/models/learning';

const EMPTY: MyLearningResponse = {
    continue: null,
    onboarding_programs: [],
    platform_modules: [],
    intro: { intro_completed: false, intro_module_id: null },
    history: [],
};

const getMyLearning = async (): Promise<MyLearningResponse> => {
    try {
        return await getApiClient().get<MyLearningResponse>('/api/my/learning');
    } catch {
        return EMPTY;
    }
};

export const learningApi = { getMyLearning };
